/**
 * Created by AlexanderC on 2/22/17.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConsoleDriver = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _AbstractDriver2 = require('./AbstractDriver');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

let ConsoleDriver = exports.ConsoleDriver = function (_AbstractDriver) {
  _inherits(ConsoleDriver, _AbstractDriver);

  function ConsoleDriver() {
    _classCallCheck(this, ConsoleDriver);

    return _possibleConstructorReturn(this, (ConsoleDriver.__proto__ || Object.getPrototypeOf(ConsoleDriver)).apply(this, arguments));
  }

  _createClass(ConsoleDriver, [{
    key: '_log',

    /**
     * @param   {String} name
     * @param   {*} data
     * @param   {Object} context
     *
     * @returns {Promise|*}
     *
     * @private
     */
    value: function _log(name, data, context) {
      return this._printEvent(name, data, context);
    }
  }]);

  return ConsoleDriver;
}(_AbstractDriver2.AbstractDriver);


//////////////////
// WEBPACK FOOTER
// ../~/deep-event/lib.compiled/Driver/ConsoleDriver.js
// module id = 383
// module chunks = 0